    import React, {Component} from 'react';
    import {connect} from 'react-redux';
    import {Redirect} from 'react-router-dom';

    import Layout from '../../components/Layout/Layout';
    import Dashboard from '../../components/Dashboard/Dashboard';
    import Overview from '../../components/Overview/Overview';
    import Detailview from '../../components/Detailview/Detailview';
    import ClusterDetail from '../../components/ClusterDetail/ClusterDetail';
    import Spinner from '../../components/Spinner/Spinner';
    import MoreData from '../../components/MoreData/MoreData'

    import { deviceActions } from '../../store/Actions';

    class ButtonDash extends Component{
        constructor(props){
            super(props);
            this.state = {
                selectedDeviceId: -1,
                selectedClusterId: -1,
                today: null,
                weekStart: null,
                lastWeek: null,
                dataDateRange: '',
                stats: [],
                loading: false,
                clusterCnt: 0,
                updating: false,
                showClusterDetail: false,
                getMoreData: false,
                extraDataCnt: 0
            };
            this.progress = 0;
        }
        
        componentDidMount(){
            let now = new Date();
            let today = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
            let dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1;
            let weekStart = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() 
                - dayOfWeek);
            let lastWeek = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() 
                - dayOfWeek - 7);
           
            //console.log(today);
            //console.log(weekStart);
            //console.log(lastWeek);
            let dataDateRange = lastWeek.getDate() + "/" + (lastWeek.getMonth() + 1) + "/" + lastWeek.getFullYear() + "|" +
                (today.getDate() + 1) + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
            //console.log(dataDateRange);
            
            this.setState({
                today: today,
                weekStart: weekStart,
                lastWeek: lastWeek,
                dataDateRange: dataDateRange,
                loading: true,
                clusterCnt: 0,
                deviceCnt: 0
            })
            this.getClusters();
        }

        getClusters = () => {
            this.props.dispatch(deviceActions.getUserClusters());
            this.progress = 0;
        }

        getClusterDevices = (cluster) => {
            const clusterID = this.props.device.clusters[cluster].ID
            this.props.dispatch(deviceActions.getClusterDevices(
                cluster, clusterID, this.state.dataDateRange, this.state.weekStart));
        }

        // getClusterDeviceData = (cluster, device) => {
        //     const deviceId = this.props.device.clusters[cluster].devices[device].id;
        //     this.props.dispatch(deviceActions.getClusterDeviceData(
        //         cluster, device, deviceId, this.state.dataDateRange, this.state.weekStart));
        // }

        sortCluster = () => {
            if (this.props.device.clusters === undefined)
                return;
            let mapped = this.props.device.clusters.map((e, i) => {
                if (e.devices === undefined)
                    return {index: i, values: []};
                return {index: i, values: e.devices.map((d, j) => {
                    return {index: j, value: d.stats};
                })}
            });

            mapped.sort((a, b) => {
                let aTotal = 0;
                let bTotal = 0;
                for(let i = 0; i < a.values.length; i++){
                    if (a.values[i].value !== undefined){
                        aTotal += a.values[i].value.aButtonPresses;
                        aTotal += a.values[i].value.bButtonPresses;
                        aTotal += a.values[i].value.cButtonPresses;
                        aTotal += a.values[i].value.dButtonPresses;
                        aTotal += a.values[i].value.eButtonPresses;    
                    }
                }
                for(let i = 0; i < b.values.length; i++){
                    if (b.values[i].value !== undefined){
                        bTotal += b.values[i].value.aButtonPresses;
                        bTotal += b.values[i].value.bButtonPresses;
                        bTotal += b.values[i].value.cButtonPresses;
                        bTotal += b.values[i].value.dButtonPresses;
                        bTotal += b.values[i].value.eButtonPresses;    
                    }
                }
                return bTotal - aTotal;
            });

            let result = mapped.map((e) => {
                return this.props.device.clusters[e.index];
            });
            this.props.device.clusters = result;
        }

        arrayMove = (arr, old_index, new_index) => {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        };

        sortClusterDevices = (cluster) => {
            if (cluster.devices === undefined)
                return;

            let mapped = cluster.devices.map((e, i) => {
                return {index: i, value: e.name};
            });

            // Sort alphabetically
            mapped.sort((a, b) => {
                return a.value.localeCompare(b.value);
            });
            
            // Sort according to preference
            if (cluster.uiConfig != null){
                try{
                    const uiConfig = JSON.parse(cluster.uiConfig);

                    if (uiConfig.buzzCSA){
                        if (uiConfig.buzzCSA.buttonOrder){
                            for (let i = 0; i < uiConfig.buzzCSA.buttonOrder.length; i++){
                                for (let j = 0; j < mapped.length; j++){
                                    if (uiConfig.buzzCSA.buttonOrder[i].localeCompare(mapped[j].value) 
                                        === 0){
                                        this.arrayMove(mapped, j, i);
                                    }
                                }
                            }
                        }
                    }
                }
                catch(err) {
                    console.log(err);
                }
            }

            // Build correct order
            let result = mapped.map((e) => {
                return cluster.devices[e.index];
            });
            cluster.devices = result;
        }

        // updateData = (cluster, device) => {
        //     if (this.props.device.status === 'ok'){
        //         if (cluster < this.props.device.clusters.length){
        //             console.log('Updating cluster ' + cluster + ' device ' + device + '...');
        //             this.getClusterDeviceData(cluster, device);
        //             device++;
        //             let devices = this.props.device.clusters[cluster].devices;
        //             if (device < devices.length){
        //                 setTimeout(() => {
        //                     this.updateData(cluster, device);
        //                 }, 1000);
        //             }
        //             else {
        //                 cluster++;
        //                 device = 0;
        //                 setTimeout(() => {
        //                     this.updateData(cluster, device);
        //                 }, 1000);
        //             }
        //             this.progress = 100 * (cluster / this.props.device.clusters.length +
        //                 device / (this.props.device.clusters.length * devices.length));
        //             this.setState({
        //                 updating: true
        //             });
        //         }
        //         else{
        //             console.log('All clusters updated.');
        //             setTimeout(() => {
        //                 this.updateData(0, 0);
        //             }, 900000);
        //             if (this.state.selectedClusterId === -1)
        //                 this.sortCluster();
        //             this.setState({
        //                 updating: false
        //             });
        //         }
        //     }
        //     else if (this.props.device.status === ''){
        //         console.log('Waiting for previous update to finish...');
        //         setTimeout(() => {
        //             this.updateData(cluster, device);
        //         }, 1000);  
        //     }
        //     else{
        //         console.log('Error during updating (' + cluster + 
        //             ':' + device + 
        //             ' ' + this.props.device.status);
        //         this.setState({
        //             updating: false
        //         });
        //     }
        // }

        componentDidUpdate(prevProps, prevState){
            if (this.props.device.loading)
                return;
            
            if (this.state.loading){
                if (this.state.extraDataCnt === 0){
                    // Start loading clusters
                    if (this.props.device.clusters.length > this.state.clusterCnt){
                        if (this.props.device.status === 'ok')
                        {
                            this.getClusterDevices(this.state.clusterCnt);
                            this.setState({
                                clusterCnt: this.state.clusterCnt + 1
                            });
                            this.progress = 10 * (this.state.clusterCnt + 1) / 
                                this.props.device.clusters.length;
                        }
                        
                        return;
                    }

                    if (this.props.device.status.includes('err'))
                    {
                        this.setState({
                            loading: false
                        });
                        return;    
                    }
                    // Check through Clusters to update data
                    for(let i = 0; i < this.props.device.clusters.length; i++){
                        let devices = this.props.device.clusters[i].devices;
                        if (devices !== undefined)
                        {
                            for(let j = 0; j < devices.length; j++){
                                if (devices[j].data === undefined){
                                    //console.log("Getting cluster " + i + " device " + j + " data");
                                    //this.getClusterDeviceData(i, j);
                                    
                                    // Update progress
                                    this.progress = 10 + (90 * (i / this.props.device.clusters.length +
                                        (j + 1) / (this.props.device.clusters.length * devices.length)));
                                    
                                    return;
                                }
                            }
                        }
                    }
                    // Sort Clusters devices
                    for(let i = 0; i < this.props.device.clusters.length; i++){
                        this.sortClusterDevices(this.props.device.clusters[i]);
                    }
                    this.sortCluster();
                    this.setState({
                        loading: false
                    });
                    // TODO Make update better network fault tolerant
                    //setTimeout(() => {
                    //    this.updateData(0, 0);
                    //}, 900000);
                }
                else{
                    let done = 1;

                    for (let i = 0; i < this.props.device.clusters.length; i++){
                        let bAllDone = true;
                        for (let j = 0; j < this.props.device.clusters[i].devices.length; j++){
                            if (this.props.device.clusters[i].devices[j].weekStats === undefined)
                                bAllDone = false;     
                        }
                        if (bAllDone)
                            done++;
                    }
                    if (done >= this.state.extraDataCnt){
                        this.setState({
                            loading: false,
                            extraDataCnt: 0
                        });
                        this.progress = 0;
                    }
                    else{
                        this.progress = 100 * done / this.state.extraDataCnt;
                    }
                }    
            }    
        }

        onClickOverview = (e) => {
            const id = e.target.id;

            this.setState({
                selectedDeviceId: id
            });
        }

        onClickShowOverview = (e) => {
            this.setState({
                selectedDeviceId: -1
            });
        }

        onClickDashboard = (clusterIndex) => {
            this.setState({
                selectedClusterId: clusterIndex
            });
        }

        onClickShowDashboard = () => {
            this.setState({
                selectedClusterId: -1,
                selectedDeviceId: -1,
                showClusterDetail: false
            });
        }

        showClusterDetail = () => {
            this.setState({
                showClusterDetail: true
            });
        }

        hideClusterDetail = () => {
            this.setState({
                showClusterDetail: false
            });
        }

        onMoreDataClicked = () => {
            this.setState({
                getMoreData: true
            });
        }

        onMoreDataClose = () => {
            this.setState({
                getMoreData: false
            });
        }

        onMoreDataUpdate = (startDate) => {
            let updateDateRange = startDate + "|" + 
                (this.state.lastWeek.getDate() + 1) + "/" + 
                (this.state.lastWeek.getMonth() + 1) + "/" + 
                this.state.lastWeek.getFullYear();
 
            for (let i = 0; i < this.props.device.clusters.length; i++){
                this.props.dispatch(deviceActions.getMoreClusterData(i, 
                    this.props.device.clusters[i], updateDateRange));
            }
            this.setState({
                getMoreData: false,
                extraDataCnt: this.props.device.clusters.length,
                loading: true
            });
            this.progress = 0;
        }

        render(){
            const deviceId = this.state.selectedDeviceId;
            const clusterId = this.state.selectedClusterId;
            let view = null;

            if (clusterId === -1){
                /*view = this.props.device.clusters.map((value, index) => {
                    return (
                        <Dashboard 
                            key={index}
                            clusterIndex={index}
                            clusterName={value.name} 
                            clusterDevices={value.devices}
                            uiConfig={value.uiConfig}
                            onClicked={this.onClickDashboard}
                        />
                    );
                })*/
                view = <Dashboard 
                    onEvent={this.onClickDashboard}
                    device={this.props.device}
                />;
            }
            else{
                if (deviceId === -1){
                    if (this.state.showClusterDetail){
                        view = <ClusterDetail 
                            cluster={this.props.device.clusters[clusterId]} 
                            onClicked={this.hideClusterDetail}
                            onDashClicked={this.onClickShowDashboard}
                            weekStartDate={this.state.weekStart}
                            onMoreDataClicked={this.onMoreDataClicked}
                            dash
                        />;
                    }
                    else{
                        view = <Overview  
                            cluster={this.props.device.clusters[clusterId]}
                            onClicked={this.onClickOverview}
                            onBackClicked={this.onClickShowDashboard}
                            weekStartDate={this.state.weekStart}
                            onShowDetailClicked={this.showClusterDetail}
                        />;
                    }
                }
                else{
                    view = <Detailview 
                        cluster={this.props.device.clusters[clusterId]}
                        device={this.props.device.clusters[clusterId].devices[deviceId]} 
                        onClicked={this.onClickShowOverview}
                        onDashClicked={this.onClickShowDashboard}
                        title={this.props.device.clusters[clusterId].name}
                        uiConfig={this.props.device.clusters[clusterId].uiConfig}
                        weekStartDate={this.state.weekStart}
                        dash
                    />;
                }
            }

            if (this.props.alert.type !== undefined){
                alert('Server returned: ' + this.props.alert.message);
                if (this.state.loading){
                    this.setState({loading: false});
                }
                if (this.props.alert.type === 'alert-danger')
                    view = <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />;
            }

            //console.log(this.state);
            return (
                <Layout>
                    <MoreData showMoreData={this.state.getMoreData} 
                        onClose={this.onMoreDataClose} onUpdate={this.onMoreDataUpdate}/>
                    {this.state.loading || this.state.updating ? 
                        <Spinner progress={this.progress}/> 
                    : 
                        null
                    }
                    {view}
                </Layout>
            )
        }
    }

    function mapStateToProps(state) {
        const { alert, device } = state;
        
        return {
            alert,
            device
        };
    }

    export default connect(mapStateToProps)(ButtonDash); 